import { Moon, Sun } from 'lucide-react';
import { useThemeStore } from '@/stores/theme.store';

/**
 * 主题切换：在浅色/深色之间切换并持久化到 localStorage。
 * 选择结果与 `@en3/shared` 的 `UserSettings.theme` 同构，将来登录后可同步到账号。
 */
export function ThemeToggle() {
  const mode = useThemeStore((s) => s.mode);
  const toggle = useThemeStore((s) => s.toggle);

  const isDark =
    mode === 'dark' ||
    (mode === 'system' &&
      typeof window !== 'undefined' &&
      window.matchMedia('(prefers-color-scheme: dark)').matches);

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={isDark ? '切换到浅色主题' : '切换到深色主题'}
      title={isDark ? '切换到浅色主题' : '切换到深色主题'}
      className="grid size-9 place-items-center rounded-md border text-muted-foreground hover:text-foreground"
    >
      {isDark ? <Sun aria-hidden className="size-4" /> : <Moon aria-hidden className="size-4" />}
    </button>
  );
}
